import { Navigate, useParams } from "react-router-dom";
import { toSlug } from "common";
import { useUser } from "../store";
import { lastDashboardOf, lastPayerOf } from "../util/lastViewed";

/**
 * Stands in for the facility and payer lists: sends the person to the dashboard they last viewed,
 * or to the first one they can see (within the facility in the URL, if there is one).
 */
export const OpenLastViewed = () => {
  const { user } = useUser();
  const { facility: facilitySlug } = useParams();
  const facilities: string[] = user?.facilities ?? [];
  const payersOf = (name: string): string[] => user?.facilitiesPayers?.[name] ?? [];

  let target: { facility: string; payer: string } | undefined;
  if (facilitySlug) {
    const facility = facilities.find((name) => toSlug(name) === facilitySlug);
    const payer = facility && (lastPayerOf(user, facility) ?? payersOf(facility)[0]);
    target = facility && payer ? { facility, payer } : undefined;
  } else {
    const last = lastDashboardOf(user);
    target = last?.payer ? { facility: last.facility, payer: last.payer } : undefined;
    if (!target) {
      const facility = facilities.find((name) => payersOf(name).length);
      target = facility ? { facility, payer: payersOf(facility)[0] } : undefined;
    }
  }

  if (target) {
    return <Navigate to={`/${toSlug(user.group)}/${toSlug(target.facility)}/${toSlug(target.payer)}`} replace />;
  }

  return (
    <main className="content">
      <div className="dashboard-empty-state">
        <span className="dashboard-empty-icon" aria-hidden="true">
          <i className="fa-solid fa-building" />
        </span>
        <h2>Nothing to show yet</h2>
        <p>No facilities or payers are assigned to you. Contact your administrator to request access.</p>
      </div>
    </main>
  );
};
